import 'selectric';
const orderFilterId = 'js-order-filter'
const collectionFilterId = 'js-collection-filter'

$('#' + orderFilterId).selectric().on('change', function() {
    let uri = window.location.href
    let url = updateQueryStringParameter(uri, 'order', $(this).val());
    window.location.href = url;
});
$('#' + collectionFilterId).selectric().on('change', function() {
    let uri = window.location.href
    let url = updateQueryStringParameter(uri, 'collection', $(this).val());
    window.location.href = url;
});

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
  }